import apiConfig from "../ApiConfig";

const BASE = "/api/customer-framework/compliance";

export const getComplianceFrameworksApi = async (customerId) => {
  const res = await apiConfig.get(`${BASE}/frameworks/`, {
    params: { customer_id: customerId },
  });
  return res.data;
};

export const getComplianceControlsApi = async (customerId, params = {}) => {
  const res = await apiConfig.get(`${BASE}/controls/`, {
    params: { customer_id: customerId, page_size: 12, ...params },
  });
  return res.data;
};

export const patchComplianceControlApi = async (controlId, customerId, body) => {
  const res = await apiConfig.patch(
    `${BASE}/controls/${controlId}/`,
    body,
    { params: { customer_id: customerId } },
  );
  return res.data;
};
